import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  title: Yup.string().min(1).required("Title is required"),
  content: Yup.string().min(1).required("Script is required"),
  categories: Yup.array().min(1, "You must have at least 1 category").max(3, "You cannot have more than 3 categories"),
});
